export const NO_SCORE_NO_CLASS_ID = 9000;
